// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/vasi-papi.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/vasi-papi/vasi-papi.js';

mount([g0]);
